import React from 'react'
import Footer from '../../Components/Footer'
import Header from '../../Components/Header'
import Sidebar from '../../Components/Sidebar'
import UpdatePartners from './UpdatePartners'

const index = () => {
  return (
        <React.Fragment>
            <div className='wrapper'>
                <Header/>
                <Sidebar/>
                <UpdatePartners/>
                <Footer/>
                
            </div>
        </React.Fragment>
    )
}

export default index